import { sharedConstants } from 'shared-helpers';

// shared constants section
export const ALLOWED_QUERY_OPERATOR = sharedConstants.ALLOWED_QUERY_OPERATOR;
export const COOKIE_NAME = sharedConstants.COOKIE_NAME;
export const USER_STATUS = sharedConstants.USER_STATUS;
export const REPORT_TYPES = sharedConstants.REPORT_TYPES;
export const TAXONOMIES = sharedConstants.TAXONOMIES;
export const UNAUTHORIZED_ERROR_MSG = sharedConstants.UNAUTHORIZED_ERROR_MSG;

export const NEWS_SEARCH_TYPE = {
    keyword: 'keyword',
    country: 'country',
    industry: 'industry',
};

export const OLD_URLS_REGEX = {
    news: /(magnitt.com)(\/news)(\/[\d]+)(\/[\w?@%&+~=*#:._-]+)/, //e.g https://magnitt.com/news/12345/item-code
    research: /(magnitt.com)(\/research)(\/[\d]+)(\/[\w?@%&+~=*#:._-]+)/, //e.g https://magnitt.com/research/12345/item-code
    investors: /(magnitt.com)(\/investors)(\/[\d]+)(\/[\w?@%&+~=*#:._-]+)/, //e.g https://magnitt.com/investors/12345/item-code
    enablers: /(magnitt.com)(\/enablers)(\/[\d]+)(\/[\w?@%&+~=*#:._-]+)/, //e.g https://magnitt.com/enablers/12345/item-code
    corporates: /(magnitt.com)(\/corporates)(\/[\d]+)(\/[\w?@%&+~=*#:._-]+)/, //e.g https://magnitt.com/corporates/12345/item-code
    startups: /(magnitt.com)(\/startups)(\/[\d]+)(\/[\w?@%&+~=*#:._-]+)/, //e.g https://magnitt.com/startups/12345/item-code
};

export const FILTERED_NEWS_URL_REGEX = /\/([en]){2}([-]){1}([a-z]{2})\/(news)/;

export const PUBLISHING_STATUS = {
    draft: 0,
    published: 1,
    unpublished: 2,
};

// contact forms type
export const CONTACT_FORM_TYPE = {
    marketing: 1,
    enterprise: 2,
    demo_request: 3,
    bespoke_report: 4
};

// mapping of form source in hubspot
export const HUBSPOT_FORM_SOURCE = {
    research_purchase_btn: 'sales_report_purchase',
    research_widgets: 'sales_report_content',
    marketing_widgets: 'sales_news',
}

//Reason for sales Contact Options
const salesContactReasonsValue = {

    development: {
        productAndSolutions: 6797,
        pricingAndOffering: 6798,
        accessSpecificReports: 6799,
        getTrialAccess: 6800,
        getIndustryData: 6801
    },
    production: {
        productAndSolutions: 6773,
        pricingAndOffering: 6774,
        accessSpecificReports: 6775,
        getTrialAccess: 6776,
        getIndustryData: 6777
    }

}

export const SALES_CONTACT_REASONS_VALUE = salesContactReasonsValue[process.env.NODE_ENV]



// research download form types
export const RESEARCH_DOWNLOAD_FORM_TYPES = {
    1: "long",
    2: "short"
};

// CAPTCHA site key
export const CAPTCHA_SITE_KEY = '6LczWC8sAAAAANQI08TH7xacXojRf7GCeu4cMnth';

const magnitt_domain = {
    development: "magtests.xyz",
    production: "magnitt.com"
};

export const MAGNITT_DOMAIN = magnitt_domain[process.env.NODE_ENV];
